const audios = {
  audioTest: './assets/audio/healing-piano.mp3',
};

export default audios;
